import React from 'react';

import { Translation } from 'giro-react-toolkit/source/Translation';

import "./AppTitle.scss";

const AppTitle = () => {
   return (
      <div className="app-title">
         <span className="app-logo"/>
         <h1><Translation resourceKey='ReachMapRes.AppTitleText' />&nbsp;</h1>
      </div>
   );
};

export default AppTitle;
